
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum SystemQuery {
	UsersOpenTaskActions = 0,
	CompanyTaskflows = 1,
	UsersOpenSalesflows = 2,
	OpenTaskActionsByType = 3,
	CompanySalesflows = 4,
	AllActiveSalesflows = 5,
	UndeliveredProductPlans = 6,
	UndeliveredOrders = 7
}
export namespace SystemQuery {
	export function getKeys(): Map<SystemQuery, string> {
		return new Map([[0, 'UsersOpenTaskActions'], [1, 'CompanyTaskflows'], [2, 'UsersOpenSalesflows'], [3, 'OpenTaskActionsByType'], [4, 'CompanySalesflows'], [5, 'AllActiveSalesflows'], [6, 'UndeliveredProductPlans'], [7, 'UndeliveredOrders']]);
	}
}
